import { render, staticRenderFns } from "./processRamDashboard.vue?vue&type=template&id=45f0aeb8&scoped=true"
import script from "./processRamDashboard.vue?vue&type=script&lang=js"
export * from "./processRamDashboard.vue?vue&type=script&lang=js"
import style0 from "./processRamDashboard.vue?vue&type=style&index=0&id=45f0aeb8&lang=sass"
import style1 from "./processRamDashboard.vue?vue&type=style&index=1&id=45f0aeb8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f0aeb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f0aeb8')) {
      api.createRecord('45f0aeb8', component.options)
    } else {
      api.reload('45f0aeb8', component.options)
    }
    module.hot.accept("./processRamDashboard.vue?vue&type=template&id=45f0aeb8&scoped=true", function () {
      api.rerender('45f0aeb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/processRamDashboard.vue"
export default component.exports